
    import './styles.scoped.css';
    export default {
  "calendar": "awsui_calendar_mgja0_6k5ct_99",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_mgja0_6k5ct_1",
  "root": "awsui_root_mgja0_6k5ct_126",
  "wide": "awsui_wide_mgja0_6k5ct_160",
  "focus-lock": "awsui_focus-lock_mgja0_6k5ct_167",
  "trigger-wrapper": "awsui_trigger-wrapper_mgja0_6k5ct_171",
  "trigger-flexbox": "awsui_trigger-flexbox_mgja0_6k5ct_175",
  "calendar-container": "awsui_calendar-container_mgja0_6k5ct_179",
  "one-grid": "awsui_one-grid_mgja0_6k5ct_182",
  "calendar-header": "awsui_calendar-header_mgja0_6k5ct_186",
  "calendar-header-months-wrapper": "awsui_calendar-header-months-wrapper_mgja0_6k5ct_192",
  "calendar-header-month": "awsui_calendar-header-month_mgja0_6k5ct_192",
  "calendar-next-month-btn": "awsui_calendar-next-month-btn_mgja0_6k5ct_211",
  "calendar-prev-month-btn": "awsui_calendar-prev-month-btn_mgja0_6k5ct_214",
  "first-grid": "awsui_first-grid_mgja0_6k5ct_218",
  "second-grid": "awsui_second-grid_mgja0_6k5ct_219",
  "date-and-time-container": "awsui_date-and-time-container_mgja0_6k5ct_223",
  "date-and-time-wrapper": "awsui_date-and-time-wrapper_mgja0_6k5ct_229",
  "footer": "awsui_footer_mgja0_6k5ct_236",
  "has-clear-button": "awsui_has-clear-button_mgja0_6k5ct_245",
  "footer-button-wrapper": "awsui_footer-button-wrapper_mgja0_6k5ct_254",
  "icon-wrapper": "awsui_icon-wrapper_mgja0_6k5ct_261",
  "label": "awsui_label_mgja0_6k5ct_266",
  "label-enabled": "awsui_label-enabled_mgja0_6k5ct_271",
  "label-text": "awsui_label-text_mgja0_6k5ct_275",
  "label-token-nowrap": "awsui_label-token-nowrap_mgja0_6k5ct_280",
  "mode-switch": "awsui_mode-switch_mgja0_6k5ct_284",
  "dropdown": "awsui_dropdown_mgja0_6k5ct_288",
  "dropdown-content": "awsui_dropdown-content_mgja0_6k5ct_310",
  "start-date-input": "awsui_start-date-input_mgja0_6k5ct_319",
  "start-time-input": "awsui_start-time-input_mgja0_6k5ct_320",
  "end-date-input": "awsui_end-date-input_mgja0_6k5ct_321",
  "end-time-input": "awsui_end-time-input_mgja0_6k5ct_322",
  "validation-section": "awsui_validation-section_mgja0_6k5ct_326",
  "validation-error": "awsui_validation-error_mgja0_6k5ct_330",
  "clear-button": "awsui_clear-button_mgja0_6k5ct_334",
  "apply-button": "awsui_apply-button_mgja0_6k5ct_338",
  "cancel-button": "awsui_cancel-button_mgja0_6k5ct_342",
  "calendar-aria-live": "awsui_calendar-aria-live_mgja0_6k5ct_346"
};
  